import { Box, Step, StepIndicator, Stepper, StepTitle } from "@chakra-ui/react";
import { useCommandUPSTracking } from "../hooks/commands.hooks";
import i18n from "../i18n";

export type UPSTrackingStepsProps = {
	id?: string | null;
};

const UPSTrackingSteps = ({ id }: UPSTrackingStepsProps) => {
	const { data: activities } = useCommandUPSTracking(id);

	if (!Array.isArray(activities)) {
		return null;
	}
	return (
		<Stepper
			index={activities.length - 1}
			orientation="vertical"
			height={`${50 * activities.length}px`}
			gap="0"
			colorScheme="brand"
		>
			{activities.map((activity, index) => (
				<Step key={index}>
					<StepIndicator></StepIndicator>

					<Box position="absolute" top="4px" left="40px" w="1000px">
						<StepTitle>
							{i18n.t(`ups.status.${activity.status.code}`)}
						</StepTitle>
					</Box>
				</Step>
			))}
		</Stepper>
	);
};

export default UPSTrackingSteps;
